import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import { Button as MuiButton, Stack, TextField } from '@mui/material';
import { autobind } from 'core-decorators';
import { Component } from 'react';
import Alert from '/@/components/bayer/alert';
import { _ } from '/@/locale';
import styles from './styles.module.css';

@autobind
export default class NameInput extends Component {
    state = {
        value: '',
    };

    handleChange(event) {
        this.setState({ value: event.target.value });
    }

    handleKeyDown(event) {
        if (event.keyCode === 13) this.handleSubmit();
    }

    handleSubmit() {
        const value = this.state.value.trim();
        if (!value) return this.setState({ value });
        if (this.props.loading || this.state.value.length > 50) return;
        return this.props.onSubmit(value);
    }

    render() {
        return (
            <div className={styles.root}>
                <div className={styles.input}>
                    <TextField
                        label={_('Ingresar el nombre del lote')}
                        variant='filled'
                        value={this.state.value}
                        onChange={this.handleChange}
                        onKeyDown={this.handleKeyDown}
                        InputLabelProps={{
                            sx: {
                                color: 'black',
                                '&.Mui-focused': { color: 'black' },
                            },
                        }}
                        sx={{
                            width: '100%',
                            color: 'red',
                            input: { background: 'white', color: 'black' },
                        }}
                    />
                </div>
                {this.state.value.length > 50 && (
                    <Alert severity='danger'>{_('El nombre del lote debe tener entre 1 y 50 caracteres')}</Alert>
                )}
                <Stack
                    direction='row'
                    spacing={2}
                    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                    <MuiButton
                        startIcon={<CloseIcon />}
                        color='error'
                        variant='contained'
                        disabled={this.props.loading}
                        onClick={this.props.onCancel}
                    >
                        {_('CANCELAR')}
                    </MuiButton>
                    <MuiButton
                        startIcon={<DoneIcon />}
                        color='success'
                        variant={
                            !this.state.value || this.props.loading || this.state.value.length > 50
                                ? 'outlined'
                                : 'contained'
                        } // this because disabled makes button disappear
                        onClick={this.handleSubmit}
                        sx={{
                            '&:hover': {
                                cursor:
                                    !this.state.value || this.props.loading || this.state.value.length > 50
                                        ? 'not-allowed'
                                        : 'pointer',
                            },
                        }} // this because disabled makes button disappear
                    >
                        {this.props.loading ? _('GUARDANDO...') : _('GUARDAR')}
                    </MuiButton>
                </Stack>
            </div>
        );
    }
}
